import loadable from '@loadable/component'

export const RatingHeader = loadable(() => import('./RatingHeader'))
export type { RatingHeaderProps, RelatedRegionsProps } from './RatingHeader'
